import { createReducer, on } from '@ngrx/store';
import {
  fetchAnnouncementSuccess,
  fetchAnnouncementFailure,
} from './announcement-dialog-actions';
import { IAnnouncementPopup } from '@app/shared/models/announcement-popups.model';

export const announcementDialogKey = 'announcementsDialog';

export interface AnnouncementDialogState {
  announcement: IAnnouncementPopup | null;
  announcementLoaded: boolean;
}

export const initialState: AnnouncementDialogState = {
  announcement: null,
  announcementLoaded: false,
};

export const AnnouncementDialogReducer = createReducer(
  initialState,
  on(
    fetchAnnouncementSuccess,
    (state: AnnouncementDialogState, { announcement }) => ({
      ...state,
      announcement: announcement,
      announcementLoaded: true,
    })
  ),
  on(fetchAnnouncementFailure, (state: AnnouncementDialogState) => ({
    ...state,
    announcementLoaded: false,
  }))
);
